// Copyright (c) 2016 Deere & Company

import PipProducts, {getDefaultState as getPipProductsDefaultState} from '../state/pip-products';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const resetPipProducts = () => getPipProductsDefaultState();

const updatePipProducts = (state, action) =>
    PipProducts.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().pipProducts, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_PIP]: resetPipProducts,
        [actions.RESET_CLAIM_PIP_PIP_PRODUCTS]: resetPipProducts,
        [actions.UPDATE_CLAIM_PIP_PIP_PRODUCTS]: updatePipProducts
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/pip/reducers/pip-products.js